/* ════════════════════════════════════════════════════════════════════
   TRANSDERMA · Italian (it) string table · dr-ronlan.html
   English is the source of truth in the HTML; this file supplies the
   Italian counterpart for each page-specific data-i18n key. Shared
   chrome (nav, announce, footer) lives in i18n-it.js.
   Proper names, institution names, journal titles, patent numbers and
   molecular names stay in their original form.
═════════════════════════════════════════════════════════════════════ */
(function () {
  window.TD_I18N = window.TD_I18N || {};
  window.TD_I18N.it = window.TD_I18N.it || {};
  Object.assign(window.TD_I18N.it, {

    /* ── Meta ── */
    'ronlan.docTitle': 'Dr. K. Alvin Ronlán · Ricerca e percorso — Transderma',

    /* ── Page header ── */
    'ronlan.headLabel': 'Ricerca e percorso',
    'ronlan.headTitle': 'Dr. K. Alvin <em>Ronlán</em>',
    'ronlan.headSub': 'Fondatore, Director of R&amp;D. Tre decenni di chimica dei fenoli, ora applicati alla pelle.',

    /* ── Quick facts ── */
    'ronlan.facts.label': 'In breve',
    'ronlan.facts.bornK': 'Nascita',
    'ronlan.facts.bornV': '15 agosto 1942, Copenaghen, Danimarca',
    'ronlan.facts.domK': 'Residenza',
    'ronlan.facts.domV': 'Florida, USA',
    'ronlan.facts.langK': 'Lingue',
    'ronlan.facts.langV': 'Danese, svedese, inglese, tedesco',
    'ronlan.facts.roleK': 'Ruolo attuale',
    'ronlan.facts.roleV': 'R&amp;D Director, Alron Chemical Co AB · Cofondatore, ProBios Laboratories, Inc.',

    /* ── Education ── */
    'ronlan.eduLabel': 'Formazione',
    'ronlan.eduTitle': 'Quattro titoli,<br><em>tre paesi.</em>',
    'ronlan.edu1h': 'B.Sc. · matematica, fisica, chimica',
    'ronlan.edu1p': 'Università di Copenaghen e Istituto Tecnico Danese.',
    'ronlan.edu2h': 'M.Sc. · fisica e chimica',
    'ronlan.edu2p': 'Università di Uppsala, Svezia.',
    'ronlan.edu3h': 'Ph.D.',
    'ronlan.edu3p': 'Royal Institute of Technology, Stoccolma, Svezia.',
    'ronlan.edu4h': 'Dottore in Scienze',
    'ronlan.edu4p': 'Università di Lund, Svezia.',

    /* ── Career ── */
    'ronlan.carLabel': 'Carriera',
    'ronlan.carTitle': 'Dall\'accademia<br><em>al laboratorio.</em>',
    'ronlan.carIntro': 'Sei decenni di insegnamento, ricerca e chimica applicata. Di seguito i punti salienti.',
    'ronlan.car1h': 'Assistente, Università di Uppsala',
    'ronlan.car1p': 'Primo incarico didattico durante gli studi di specialistica.',
    'ronlan.car2h': 'Assistente di ricerca, Royal Institute of Technology, Stoccolma',
    'ronlan.car2p': 'Gli anni del dottorato a Stoccolma.',
    'ronlan.car3h': 'Docent, Università di Lund',
    'ronlan.car3p': 'Avvia il lavoro su chimica dei fenoli e ossidazione anodica che in seguito sosterrà la formulazione di Transderma.',
    'ronlan.car4h': 'Professore associato, Università di Lund',
    'ronlan.car5h': 'Professore ordinario, Università di Lund',
    'ronlan.car5p': 'Promosso a professore ordinario di chimica bioorganica, dirige il gruppo di ricerca su antiossidanti fenolici e radicali cationici.',
    'ronlan.car6h': 'Direttore del Dipartimento di Chimica, Università di Lund',
    'ronlan.car6p': 'Dirige il dipartimento di chimica dell\'Università di Lund.',
    'ronlan.car7h': 'Director of R&amp;D, Alron Chemical Co AB',
    'ronlan.car7p': 'In corso · ha fondato il laboratorio nel 1977 per chimica e fisica delle superfici e catalisi di combustione. Lo stesso anno viene fondata anche Alron Japan, Inc. a Tokyo.',
    'ronlan.car8h': 'Professore visitante, University of California, Santa Cruz',
    'ronlan.car8p': 'Applica la prima intelligenza artificiale a problemi chimici e biochimici.',
    'ronlan.car9h': 'Cofondatore e R&amp;D Director, ProBios Laboratories, Inc.',
    'ronlan.car9p': 'Insieme a Graziella Gallelli Ronlan. Ricerca e sviluppo con sede in Florida.',
    'ronlan.car10h': 'Consulente, Erco Pharmaceuticals',
    'ronlan.car10p': 'Coautore di brevetti su mezzi di contrasto e farmaci antipertensivi.',
    'ronlan.car11h': 'Spedizione in Africa orientale',
    'ronlan.car11p': 'Ha organizzato e guidato una spedizione di quattro mesi in Kenya, Tanzania e Uganda per la raccolta di piante medicinali.',

    /* ── Publications ── */
    'ronlan.pubLabel': 'Pubblicazioni selezionate',
    'ronlan.pubTitle': 'Fenoli, antiossidanti,<br><em>radicali cationici.</em>',
    'ronlan.pubIntro': 'Dieci articoli sottoposti a revisione paritaria che mostrano la chimica alla base delle formulazioni Transderma. La bibliografia completa di 31 articoli è disponibile nel download del CV.',
    'ronlan.pub1': '<em>Phenol Dehydrogenation. Intramolecular Oxidative Coupling of Dihydropiceatannol.</em> Acta Chem. Scand., 23, 249 (1969). Con Holger Erdtman.',
    'ronlan.pub2': '<em>The Structure of Mezerein, A Major Toxic Principle of Daphne Mezerum L.</em> Tetrahedron Letters, 1970, 4261. Con Börje Wickberg.',
    'ronlan.pub3': '<em>Coupling of Phenols via an Anodically Generated Ion.</em> Chem. Commun., 1971, 1643.',
    'ronlan.pub4': '<em>Anodic Oxidation of Phenolic Compounds. Part II. Products and Mechanisms of the Anodic Oxidation of Hindered Phenols.</em> J. Chem. Soc., C, 1971, 3241. Con V.D. Parker.',
    'ronlan.pub5': '<em>Kinetics and Mechanisms of the Reaction of Organic Cation Radicals and Dications.</em> J. Amer. Chem. Soc., 96, 5108 (1974). Con V.D. Parker e U. Svanholm.',
    'ronlan.pub6': '<em>Anodic Oxidation of Phenolic Compounds. Part V. Anodic Methoxylation of Phenols.</em> J. Chem. Soc. Perk I, 1978, 696.',
    'ronlan.pub7': '<em>Anodic Coupling of Simple Aryl Ethers.</em> Tetrahedron Letters, 1972, 2272.',
    'ronlan.pub8': '<em>The Direct Observation of Intermediates During the Oxidative Cyclization of Phenol Ethers.</em> Acta Chem. Scand., 1974.',
    'ronlan.pub9': '<em>Electrosynthesis of Medium and Large Sized Rings by Oxidative Cyclization.</em> J. Org. Chem., 39, 1014 (1974).',
    'ronlan.pub10': '<em>The Relative Ease of Oxidation of Phenols and Phenol Ethers.</em> Acta Chem. Scand., 1976.',
    'ronlan.pub11': '<em>Systematic Derivation of Chemical Procedures for Transforming Surplus Hazardous Chemicals to Useful Products.</em> Journal of Hazardous Materials, 1984.',
    'ronlan.pubFull': 'La bibliografia completa di 31 articoli sottoposti a revisione paritaria è disponibile nel download del CV.',

    /* ── Patents ── */
    'ronlan.patLabel': 'Brevetti',
    'ronlan.patTitle': 'Sette brevetti,<br><em>uno centrale per la pelle.</em>',
    'ronlan.patFeatBadge': 'La base di Transderma',
    'ronlan.patFeatTitle': 'US Pat. 20080118449 · Cosmetic Formulations of Piceatannol and Retinoids and Methods of Use Thereof',
    'ronlan.patFeatBody': 'Questo brevetto è la base chimica di Transderma. Il piceatannol è il principio attivo del Serum R; i retinoidi (palmitato di retinile) sono il principio attivo del Serum A. Il brevetto descrive come queste due molecole agiscono insieme sulla pelle.',
    'ronlan.patFeatLinkA': 'Acquista Serum R',
    'ronlan.patFeatLinkB': 'Acquista Serum A',
    'ronlan.pat1': 'US Pat. 6,500,465 · Composizione disinfettante e sporicida · bonifica di edifici.',
    'ronlan.pat2': 'US Pat. 5,540,767 · Composizione e metodo per l\'equilibratura di pneumatici.',
    'ronlan.pat3': 'US Pat. 5,431,726 · Composizione di equilibratura.',
    'ronlan.pat4': 'US Pat. 4,867,792 · Composizione per l\'equilibratura di pneumatici.',
    'ronlan.pat5': 'European Patent EP1196299 · Composizioni per l\'equilibratura di pneumatici.',
    'ronlan.pat6': 'European Patent EP0281252 · Composizione e metodo per l\'equilibratura di pneumatici.',

    /* ── Shop CTA ── */
    'ronlan.ctaLabel': 'La chimica applicata',
    'ronlan.ctaTitle': 'Il brevetto è<br><em>nel flacone.</em>',
    'ronlan.ctaBody': 'Due dei cinque sieri Transderma provengono direttamente dal brevetto cosmetico del Dr. Ronlán. Comincia da lì, oppure prova l\'intero sistema nel Discovery Kit.',
    'ronlan.ctaBtnR': 'Serum R · Piceatannol',
    'ronlan.ctaBtnA': 'Serum A · Retinoide',
    'ronlan.ctaBtnKit': 'Discovery Kit · tutti e cinque',

    /* ── PDF download footer ── */
    'ronlan.dlNote': 'Preferisci il documento originale?',
    'ronlan.dlLink': 'Scarica il CV completo (PDF) →'

  });
})();
